import React, { useEffect, useState } from 'react';
import { Box, HStack, Input, Popover, PopoverTrigger, PopoverContent, PopoverBody, useColorModeValue } from '@chakra-ui/react';
import ColorPicker from './ColorPicker';

export type ColorPickerPopoverProps = {
  value: string;
  onChange: (hex: string) => void;
  recentStorageKey?: string;
};

const ColorPickerPopover: React.FC<ColorPickerPopoverProps> = ({ value, onChange, recentStorageKey }) => {
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const inputBg = useColorModeValue('white', 'gray.800');
  const [internal, setInternal] = useState<string>(value || '#000000');

  useEffect(() => {
    setInternal(value || '#000000');
  }, [value]);

  return (
    <Popover
      placement="bottom-start"
      closeOnBlur
      closeOnEsc
      autoFocus={false}
      returnFocusOnClose={false}
    >
      <PopoverTrigger>
        <HStack
          spacing={2}
          cursor="pointer"
          align="center"
        >
          <Box
            width="32px"
            height="32px"
            borderRadius="full"
            borderWidth="1px"
            borderColor={borderColor}
            bg={value || '#000000'}
          />
          <Input
            value={(value || '').toUpperCase()}
            isReadOnly
            size="sm"
            maxW="120px"
            fontFamily="mono"
            bg={inputBg}
          />
        </HStack>
      </PopoverTrigger>
      <PopoverContent w="auto" maxW="280px" _focus={{ boxShadow: 'none' }}>
        <PopoverBody p={3}>
          <ColorPicker
            value={internal}
            onChange={(hex) => {
              setInternal(hex);
              onChange(hex);
            }}
            onChangeComplete={(hex) => {
              setInternal(hex);
              onChange(hex);
            }}
            recentStorageKey={recentStorageKey}
            compact
          />
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

export default ColorPickerPopover;
